export const SET_SEARCH_FILTER: string = 'SEARCH_FILTER';
export const RESET_SEARCH_FILTER: string = 'RESET_SEARCH_FILTER';
